import { Link } from 'react-router-dom'

import Emoji from 'common/emoji'

import HoldingPage from '../holdingPages/Page'

export const HOLDING_PAGE_TITLE = 'Ahh shucks!'

type Props = {
  onHomeClick?: () => void
}

const GlobalErrorContent = ({ onHomeClick }: Props) => {
  return (
    <HoldingPage>
      <HoldingPage.Title className="mb-8">
        {HOLDING_PAGE_TITLE}
      </HoldingPage.Title>
      <HoldingPage.Title>That was unlucky.</HoldingPage.Title>
      <HoldingPage.SubTitle className="mb-8">
        Unexpected page load error.
      </HoldingPage.SubTitle>
      <HoldingPage.Text className="max-w-125">
        Try refreshing the page, going to the{' '}
        <Link
          to="/"
          className="text-orange-500 hover:underline"
          onClick={onHomeClick}
        >
          homepage
        </Link>{' '}
        or chat with us. We can fix just about anything. <Emoji symbol="😉" />
      </HoldingPage.Text>
    </HoldingPage>
  )
}

export default GlobalErrorContent
